<template>
  <div>
    <static-fullscreen-card v-show="!idItemShow">
      <template v-slot:title>
        <v-breadcrumbs :items="deep" class="pa-1">
          <template v-slot:divider>
            <v-icon>mdi-forward</v-icon>
          </template>
          <template v-slot:item="{ item }">
            <v-btn @click="onGoto(item)"> {{ item.text }} </v-btn>
          </template>
        </v-breadcrumbs>
      </template>
      <template v-slot:header></template>
      <template v-slot:actions>
        <v-btn color="primary" @click="$refs.table.updateData()"><btn-title icon="fas fa-sync-alt">Обновить</btn-title> </v-btn>
        <v-btn color="primary" v-if="getAccess('education.create')" @click="createNew()" title="Создать элемент"
          ><btn-title icon="far fa-plus-square">Создать</btn-title>
        </v-btn>
      </template>
      <portal to="v-main">
        <s-edit-form
          v-model="showEditDialog"
          v-if="showEditDialog"
          :api="url"
          :m="m"
          :id="idEdit"
          :configForm="{ type: 'default' }"
          :init-data="{ parent_id }"
          :opt="{ closeAfterSave: true, delete: true }"
        >
        </s-edit-form>
      </portal>
      <a-table-f-api ref="table" :api="m.api" :defaults="defaults" :model="getModelList(m)" :useQuery="false" @click="onClickRow($event)">
        <template v-slot:item.actions="{ row }">
          <v-btn v-if="getAccess('education.edit')" x-small fab class="ma-0" color="green" title="Редактировать" @click.stop="showEditDialogFun(row.id)">
            <v-icon small>fas fa-pen</v-icon>
          </v-btn>
        </template>
      </a-table-f-api>
    </static-fullscreen-card>
    <ViewItem v-if="idItemShow" :idShow="idItemShow" @close="itemShowClose($event)" />
  </div>
</template>

<script>
import { getAccess, genModel, doubleClickDetect, keyDetect } from "@/components/mixings";
export default {
  mixins: [getAccess, genModel, doubleClickDetect, keyDetect],
  components: {
    ViewItem: () => import("./view/chain"),
  },
  data() {
    return {
      deep: [{ id: 0, text: "/" }],
      idItemShow: 0,
      idEdit: 0,
      showEditDialog: false,
      dataTable: [],
      title: "",
      parent_id: 0,
      m: this.$store.getters["config/get"].models.education.chain,
    };
  },
  created() {
    this.$root.title = "Система обучения";
  },

  computed: {
    defaults() {
      let res = {
        sort: [
          //{ key: `case when id=${this.parent_id} then 0 else 1 end`, order: "ASC" },
          { key: "is_parent", order: "DESC" },
          { key: "id", order: "ASC" },
        ],
        filters: { parent_id: this.parent_id },
        // filters: { OR: [{ id: this.parent_id }, { parent_id: this.parent_id }] },
        folder_id: this.parent_id,
        paramName: "",
      };
      return res;
    },
    url() {
      return this.m.api;
    },
  },
  watch: {
    showEditDialog() {
      if (!this.showEditDialog) {
        this.$refs.table.updateData();
      }
    },
  },
  methods: {
    onGoto(e) {
      if (this.deep.length == 1) return;
      let idx = this.deep.findIndex(d => d.id == e.id);
      if (idx < 0) return;
      let parent = this.deep[idx].id;
      let deep = [...this.deep];
      deep.splice(idx + 1);
      this.deep = deep;
      this.parent_id = parent;
    },
    itemShowClose() {
      this.loading = true;
      this.$refs.table.updateRowData(this.idItemShow);
      this.idItemShow = 0;
      this.loading = !true;
    },

    onClickRow(d) {
      if (d.field.name == "actions") {
        return;
      } else if (d.row.is_parent) {
        if (this.parent_id != d.row.id) {
          this.parent_id = d.row.id;
          this.deep.push({ id: d.row.id, text: d.row.name });
        } else {
          this.parent_id = d.row.parent_id;
          let deep = [...this.deep];
          deep.splice(this.deep.length - 1);
          this.deep = deep;
        }
        return;
      }
      this.idItemShow = d.row.id;
    },
    createNew() {
      this.showEditDialogFun(0);
    },
    showEditDialogFun(id) {
      console.log("showEditDialogFun");
      this.idEdit = id;
      this.showEditDialog = true;
    },
  },
};
</script>
